import { render } from "./manage faq's.vue?vue&type=template&id=34cb9e61"
import script from "./manage faq's.vue?vue&type=script&lang=js"
export * from "./manage faq's.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__